import { Injectable } from '@angular/core';
import { HighFivesRequestParams } from '@app/api/api-models';
import { DateTransform } from '../utils/date.transform';
import { SortHighFivesField } from '@app/shared/enums';

@Injectable()
export class HighFiveDataService {
  public defaultDates = {
    StartDate: DateTransform.subtract(new Date(), 'months', 1),
    EndDate: new Date()
  };

  public highFiveRequestParams: HighFivesRequestParams = {
    UserId: '',
    StartDate: this.defaultDates.StartDate.toISOString(),
    EndDate: this.defaultDates.EndDate.toISOString(),
    OrderBy: SortHighFivesField.CreatedAt,
    IsOrderByDescending: true,
    CreatedByIds: [],
    PageSize: 25,
    PageNumber: 1
  };
}
